import downloadBlob from "~/helpers/downloadBlob";
import fetchWithAuthRetry from "~/services/fetchWithAuthRetry";

const FILE_NAME = "invoices.zip";

const downloadBackgroundJobFile = async (resultLink: string): Promise<void> => {
	const response = await fetchWithAuthRetry(resultLink);
	if (!response.ok) throw new Error(`Background job download failed (status ${response.status})`);
	downloadBlob(await response.blob(), FILE_NAME);
};

export default downloadBackgroundJobFile;
